import { render, staticRenderFns } from "./AppALoad.vue?vue&type=template&id=b5a65d6e&scoped=true&"
import script from "./AppALoad.vue?vue&type=script&lang=js&"
export * from "./AppALoad.vue?vue&type=script&lang=js&"
import style0 from "./AppALoad.vue?vue&type=style&index=0&id=b5a65d6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a65d6e",
  null
  
)

export default component.exports